export default __webpack_public_path__ + "static/media/cert-general2024-cpttm-sc.c85cff69.jpg";